import type { IUpdater } from '@erp/native/interfaces';

/**
 * Web auto-update is the browser's job — Cloudflare Pages serves the
 * latest assets on every reload. We expose a no-op updater so the UI
 * doesn't need to branch on platform when rendering the "check for
 * updates" button (it just shows nothing).
 */
export function createWebUpdater(): IUpdater {
  return {
    async check() {
      return { phase: 'idle' as const };
    },
    subscribe() {
      return () => {};
    },
    async installAndRelaunch() {
      window.location.reload();
    },
  };
}
